export default "__VITE_ASSET__DL7R4rlv__"